export enum UserRoles {
    admin = 'Admin',
    sales = 'Sales',
    employee = 'Employee',
    user = 'User'
}
